import React, { useState } from "react";
import { formatNaira } from "../../productsData";
import { useCart } from "../../context/CartContext";

export default function OrderSummary() {
  const { subtotal, shipping, tax, total, items } = useCart();
  const [promo, setPromo] = useState("");

  return (
    <div className="order-summary-card">
      <h5>Order Summary</h5>
      <div className="order-summary-row">
        <span>Subtotal</span>
        <span>{formatNaira(subtotal)}</span>
      </div>
      <div className="order-summary-row">
        <span>Shipping</span>
        <span>{formatNaira(shipping)}</span>
      </div>
      <div className="order-summary-row">
        <span>Tax</span>
        <span>{formatNaira(tax)}</span>
      </div>
      <div className="order-summary-row order-summary-total">
        <span>Total</span>
        <span>{formatNaira(total)}</span>
      </div>

      <div className="promo-row">
        <input
          type="text"
          placeholder="Promo code"
          value={promo}
          onChange={(e) => setPromo(e.target.value)}
        />
        <button type="button" className="btn-mu-outline">Apply</button>
      </div>

      <button type="button" className="btn-mu-solid w-100 mt-3" disabled={!items.length}>
        Proceed to Checkout &rarr;
      </button>
    </div>
  );
}
